module.exports = __webpack_public_path__ + "static/bimbo_logo_crop-939a76cd76ac5004b786358e7d966d16.png";